var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.serialModel.showTimer)?_c('div',{staticClass:"d-none"},[_c('p',{attrs:{"id":"serial_timer"}},[_c('span',{staticClass:"text-time"},[_vm._v("รหัสจะหมดอายุภายใน ")]),_c('span',{staticClass:"number-time",class:{'serial-expired': _vm.timer.isExpired}},[_vm._v(" "+_vm._s(_vm.timer.displayTime)+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }